<template>
  <article id="main-content" class="page-template">
    <Sidebar/>

    <section class="page-container" aria-label="Container">
      <div class="page-content-wrapper">
        <div class="event-list-header">
          <h1 class="event-list__title"><em>Campus</em> Calendar</h1>

          <div class="event-subscribe-cta" v-if="!subscribeOpen">
            <img alt="calendar-icon" :src="assets.calendarEmail"/>

            <div class="event-subscribe-cta__details">
              <div class="event-subscribe-cta__title">Subscribe to Calendar</div>
              Receive notifications and updates for upcoming events.
            </div>

            <button type="button" class="btn" @click="toggleSubscribe">Get Started</button>
          </div>
        </div>

        <CalendarSubscribe v-if="subscribeOpen"/>

        <EventList/>
      </div>
    </section>
  </article>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import EventList from './components/EventList'
import Sidebar from './components/Sidebar'
import CalendarSubscribe from './components/CalendarSubscribe'

export default {
  name: 'EventCalendar',

  components: {
    EventList,
    Sidebar,
    CalendarSubscribe
  },

  data() {
    return {
      subscribeOpen: false
    }
  },

  computed: {
    ...mapState([
      'assets'
    ])
  },

  methods: {
    ...mapMutations([
      'loadInitialData'
    ]),

    getInitialData () {
      const initialData = JSON.parse(document.getElementById('calendar-data').textContent)
      this.loadInitialData(initialData)
    },

    toggleSubscribe() {
      this.subscribeOpen = !this.subscribeOpen
    }
  },

  created() {
    this.getInitialData()
  }
}
</script>
